/**
 * 获取单卡片表单中唯一卡片的属性路径
 * @param obj 要检查的对象，通常是一个 schema 的 properties 对象
 * @returns 卡片属性路径（字符串），若无或有多个卡片则返回 null
 */
export function getOnlyCardPath(obj) {
    if (!obj || typeof obj !== 'object') {
        return null;
    }
    let foundKey = null;
    for (const key in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, key)) {
            continue;
        }
        const item = obj[key];
        if (item && typeof item === 'object' && item['x-component'] === 'CnCard') {
            if (foundKey) {
                // 已经找到一个卡片，再次遇到说明不是唯一，直接返回 null
                return null;
            }
            foundKey = key;
        }
    }
    return foundKey;
}
